import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import Logo from "../../header/images/logo.png";
import "./MenuPlans.css";

const MenuPlans = ({
  onBack,
  backTo = "/viewplans",
  backLabel = "Inapoi"
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }

    navigate(backTo);
  };

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <header className="menu-plans">
      <div className="menu-plans-inner">

        <button
          type="button"
          className="menu-plans-logo-button"
          onClick={handleLogoClick}
          aria-label="Pagina principala ContaLearn"
        >
          <img
            src={Logo}
            alt="ContaLearn"
            className="menu-plans-logo"
          />
        </button>

        <button
          type="button"
          className="menu-plans-back"
          onClick={handleBack}
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            className="menu-plans-back-icon"
          />

          <span>{backLabel}</span>
        </button>

      </div>
    </header>
  );
};

export default MenuPlans;